(function ($) {
  $(function () {
    const $filterForm = $('.js-archive-filter');
    if (!$filterForm.length) return;

    const postType = $filterForm.data('post-type');
    const config = window.archiveFilterConfig ?? {};
    if (!config.restUrl) return;

    const getResultsEl = () => $('#c-archive-results');
    const getPaginationEl = () => $('.js-archive-pagination');
    const getSectionEl = () => $('.c-overview[data-archive]');

    const collectParams = (overrides = {}) => {
      const params = new URLSearchParams();
      $filterForm.find('select').each(function () {
        if (this.value) params.set(this.name, this.value);
      });
      Object.entries(overrides).forEach(([key, value]) => {
        if (value) params.set(key, String(value));
        else params.delete(key);
      });
      return params;
    };

    const pushUrl = (params) => {
      const query = params.toString();
      history.pushState({}, '', query ? `?${query}` : location.pathname);
    };

    // Held so a rapid second filter or pagination click cancels the request
    // still in flight, which would otherwise land after it and restore
    // results the URL no longer describes.
    let activeRequest = null;

    const fetchResults = (params) => {
      const $section = getSectionEl();
      $section.addClass('is-loading');

      if (activeRequest) activeRequest.abort();

      activeRequest = $.ajax({
        url: `${config.restUrl}${postType}?${params.toString()}`,
        dataType: 'json',
      })
        .done(function (data) {
          const $doc = $('<div>').html(data.html);

          const $newResults = $doc.find('#c-archive-results');
          if ($newResults.length) getResultsEl().replaceWith($newResults);

          const $curPag = getPaginationEl();
          const $newPag = $doc.find('.js-archive-pagination');

          if ($curPag.length && $newPag.length) $curPag.replaceWith($newPag);
          else if ($curPag.length && !$newPag.length) $curPag.remove();
          else if (!$curPag.length && $newPag.length) getResultsEl().after($newPag);

          bindPagination();
        })
        .fail(function (xhr, status) {
          if (status === 'abort') return;
          console.error('Archive filter error:', xhr.status);
        })
        .always(function (_result, status) {
          // A newer request is already loading, so it owns the state now.
          if (status === 'abort') return;
          activeRequest = null;
          $section.removeClass('is-loading');
        });
    };

    const bindPagination = () => {
      getPaginationEl()
        .find('a')
        .on('click', function () {
          const page =
            new URL(this.href).searchParams.get('paged') ?? '1';
          const params = collectParams({
            paged: page !== '1' ? page : undefined,
          });
          pushUrl(params);
          fetchResults(params);
          const $section = getSectionEl();
          if ($section.length) {
            $('html, body').animate(
              { scrollTop: $section.offset().top },
              300
            );
          }
          return false;
        });
    };

    $filterForm.find('button').on('click', function () {
      const params = collectParams();
      pushUrl(params);
      fetchResults(params);
      return false;
    });

    $filterForm.on('submit', function () {
      const params = collectParams();
      pushUrl(params);
      fetchResults(params);
      return false;
    });

    bindPagination();
  });
})(jQuery);
